import { render, staticRenderFns } from "./BodyCompositionDialog.vue?vue&type=template&id=33f73a7c&scoped=true"
import script from "./BodyCompositionDialog.vue?vue&type=script&lang=js"
export * from "./BodyCompositionDialog.vue?vue&type=script&lang=js"
import style0 from "./BodyCompositionDialog.vue?vue&type=style&index=0&id=33f73a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f73a7c",
  null
  
)

export default component.exports